<template>
  <v-dialog
    :key="data.dialogsharecard"
    v-model="data.dialogsharecard"
    width="500"
    content-class="elevation-0 rounded-xl"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        block
        elevation="0"
        class="text-center mt-4"
        text
        color="primary"
      >
        Card delen
      </v-btn>
    </template>

    <v-card
      elevation="0"
      class="h-100 py-5 px-2 pa-md-10 rounded-xl"
      color="white align-center"
    >
      <div class="d-flex">
        <v-btn
          color="primary"
          class="position-absolute"
          icon
          text
          @click="data.dialogsharecard = false"
        >
          <v-icon color="primary">fal fa-times</v-icon></v-btn
        >
      </div>

      <h4
        v-text="'Card delen'"
        color="primary"
        class="
          headline
          font-weight-bold
          text-center
          mx-auto
          d-block
          text-primary
          mb-2
        "
      ></h4>

      <p class="text-center">
        Deel deze card met andere Kyano gebruikers.
      </p>

      <v-text-field
        v-model="invitecardshare"
        label="E-mailadres uitnodigen"
        outlined
        hint="Vul hier een e-mailadres in met wie je deze card wilt delen."
        persistent-hint
      ></v-text-field>


       <v-switch
      v-model="invitecardshareswitch"
      label="Rechten aanpassen"
    ></v-switch>

    <div v-if="invitecardshareswitch === true">

<ShareCardSettings :data="data"/>

    </div>
   
      <v-spacer class="my-10"></v-spacer>

      <v-btn       
        color="secondary"
        class="my-4"
        large        
        block
        elevation="0"
        to="/profiles/create"
      >
        Uitnodigen
      </v-btn>
    </v-card>
  </v-dialog>
</template>
<script>

import ShareCardSettings from "./ShareCardSettings.vue";
export default {
components: {
  ShareCardSettings,
},
  props: {
    data: Object
  },
  data() {
    return {
      selectprofile: null,
     invitecardshareswitch: false,
      rules: {
        required: (value) => !!value || "Verplicht.",
        min: (v) => v.length >= 8 || "Min 8 tekens",
        emailMatch: () => `The email and password you entered don't match`,
      },
    };
  },
};
</script>

